import { Outlet, Link } from 'react-router-dom'
import Footer from '../components/Footer'

export default function AuthLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="/branding/cte-course-platform-icon.svg" 
              alt="CTE Course Platform" 
              className="h-8 w-8"
            />
            <span className="text-2xl font-bold bg-gradient-to-r from-cte-blue to-cte-blue-dark bg-clip-text text-transparent">
              CTE Course Platform
            </span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="max-w-6xl w-full bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <Outlet />
        </div>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  )
}
